import { Field, useField, useFormikContext } from "formik";
import { CMDropdown, CMDropdownContainer } from "./dropdown.styles";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  MenuItem,
} from "@mui/material";
import { ReactComponent as ArrowIcon } from "../../icons/arrow-down-short.svg";
import { useEffect, useRef, useState } from "react";

export const FormField = ({ field, ...props }) => {
  return <CMDropdown {...field} {...props} IconComponent={ArrowIcon} className="dropdown"/>;
};

const Dropdown = ({
  options,
  name,
  defaultValue,
  isFormikControl = true,
  className,
  ...props
}) => {
  
  const { getFieldProps, setFieldValue } = useFormikContext();
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const [field, meta, helpers] = useField(name || "newField" );
  const dropdownRef = useRef(null);

  const handleContainerKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      if (dropdownRef.current.value !== defaultValue) {
        setFieldValue(name, dropdownRef.current.value);
      }
    }
  };

  const handleItemFocus = (index) => {
    setFocusedIndex(index);
  };

  const handleChange = (e) => {
    setFieldValue(name, e.target.value);
    if (props.onChange) {
      props.onChange(e); 
    }
  };

  useEffect(() => {
    if (!field.value && defaultValue !== undefined) {
      setFieldValue(name, defaultValue);
    }
  }, [defaultValue, field.value]);

  useEffect(() => {
    return () => {
      setFocusedIndex(-1);
    };
  }, []);

  const effectiveDefaultValue = defaultValue !== undefined ? defaultValue : options[0]?.value || '';

  return (
    <>
      <CMDropdownContainer className={`dropdown-container ${className}` } onKeyDown={handleContainerKeyDown} ref={dropdownRef} tabIndex="0">
        <FormControl>
          {isFormikControl ? (
            <Field as="select" name={name} component={FormField} defaultValue={effectiveDefaultValue} onChange={handleChange} {...props}>
              <MenuItem value={"selected"} disabled>Select</MenuItem>
              {props.multiple === true
                ? options.map((option, index) => (
                    <MenuItem key={index} value={option.value} onFocus={() => handleItemFocus(index)}>
                      <Checkbox
                        checked={
                          props.value.findIndex((e) => e === option.value) !==
                          -1
                        }
                      />
                      {option.text}
                    </MenuItem>
                  ))
                : options.map((option, index) => (
                    <MenuItem key={index} value={option.value} onFocus={() => handleItemFocus(index)}>
                      {option.text}
                    </MenuItem>
                  ))}
            </Field>
          ) : (
            <FormField {...props} defaultValue={effectiveDefaultValue}>
              <MenuItem value="" disabled>
                Select
              </MenuItem>
              {props.multiple === true
                ? options.map((option, index) => (
                    <MenuItem key={index} value={option.value} onFocus={() => handleItemFocus(index)}>
                      <Checkbox
                        checked={
                          props.value.findIndex((e) => e === option.value) !==
                          -1
                        }
                      />
                      {option.text}
                    </MenuItem>
                  ))
                : options.map((option, index) => (
                    <MenuItem key={index} value={option.value} onFocus={() => handleItemFocus(index)}>
                      {option.text}
                    </MenuItem>
                  ))}
            </FormField>
          )}
        </FormControl>
      </CMDropdownContainer>
    </>
  );
};

export default Dropdown;
